module.exports = __webpack_public_path__ + "static/img/Aquatics-Center-Diving.58073aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aquatics-Center-Diving.jpg
// module id = JjXj
// module chunks = 0